import { FieldValue } from 'src/data-capture/types';

export function isEmpty(value: FieldValue): boolean {
  return (
    value == null ||
    (typeof value === 'string' && value.trim() === '') ||
    (Array.isArray(value) && value.length === 0)
  );
}
